import {sprites} from 'sprites'
import {createEl} from '../createElement'
import {playAudio} from '../audio/playAudio'

function loadSprites() {
  let spriteNames = Object.keys(sprites)
  for(let i = 0; i < spriteNames.length; i++) {
    let spriteName = spriteNames[i]
    let sprite = sprites[ spriteName ]
    let stateNames = Object.keys(sprite['states'])
    for(let k = 0; k < stateNames.length; k++) {
      let stateName = stateNames[k]
      let file = sprites[spriteName]['states'][stateName]
      let image = new Image()
      image.src = 'media/' + file.src
    }
  }
}

function createSprite(name, parent = null) {
  const def = sprites[name]
  let el = createEl(def.el, {"data-sprite": name}, parent)
  const mediaPath = 'media/'
  // bind set state function
  el.setState = function(state, props) {
    setState(name, state, props)
  }
  // add elements
  if(def.type === 'image') {
    for (const [key, value] of Object.entries(def.states) ) {
      createEl('div', {"class": "state", "data-state": key, style: `background-image:url('${mediaPath + value.src}'); opacity: 0;`}, el)
    }
  }
  // bind events
  if( def.hasOwnProperty('events') ) {
    for (const [key, value] of Object.entries(def.events) ) {
      el.addEventListener(key, function() {
        setState(name, value)
      })
    }
  }
  // set initial state
  setState(name, def.initialState)
  return el
}

function setState(name, state, props = null) {
  let spriteEl = document.querySelector(`[data-sprite="${name}"]`)
  if(! spriteEl) {
    console.warn(`No sprite found by the name of ${name}. Could not set the state ${state}.`)
    return
  }
  spriteEl.setAttribute('data-state', state)
  let spriteDef = sprites[name]
  let spriteState = spriteDef['states'][state]
  let stateImages = spriteEl.querySelectorAll(`[data-state]`)
  for(let i = 0; i < stateImages.length; i++) {
    let stateImage = stateImages[i]
    stateImage.style.opacity = 0
    if( stateImage.getAttribute('data-state') == state ) {
      stateImage.style.opacity = 1
    }
  }
  // play audio
  if( spriteState.hasOwnProperty('sound') ) {
    playAudio(spriteState.sound)
  }
  // callback, if specified
  if( typeof props === 'object' && props !== null && props.hasOwnProperty('onEnd') ) {
    props.onEnd()
  }
}

export {loadSprites, createSprite, setState}
